import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { STUDIO_INQUIRY_STUDIO_OPERATIONS } from '../../constants/common';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-studio-inquiry-studio-operations',
    templateUrl: './studio-inquiry-studio-operations.component.html',
    styleUrls: ['./studio-inquiry-studio-operations.component.scss'],
    standalone: false
})
export class StudioInquiryStudioOperationsComponent implements OnInit {
  /** Everything captured on the earlier steps of the inquiry */
  @Input() projectInformation: any;
  /** Values captured earlier, so stepping back and forward does not lose them */
  @Input() studioOperations: any;
  @Output() studioOperationsSubmitted = new EventEmitter<any>();
  constants = STUDIO_INQUIRY_STUDIO_OPERATIONS;
  operationsForm!: FormGroup;

  constructor(
    private readonly formBuilder: FormBuilder,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    const exteriorSetControls: Record<string, boolean[]> = {};
    this.constants.exteriorSetOptions.forEach((option) => {
      exteriorSetControls[option.id] = [false];
    });

    this.operationsForm = this.formBuilder.group(
      {
        soundStages: [false],
        exteriorSets: [false],
        exteriorSetSelections: this.formBuilder.group(exteriorSetControls),
        additionalRequirements: [''],
        officeSpaceRequired: ['', Validators.required],
      },
      { validators: this.locationChoiceValidator }
    );

    if (this.studioOperations) {
      this.operationsForm.patchValue(this.studioOperations);
    }
  }

  /**
   * locationChoiceValidator() - Location Choice is required, so at least one of
   * the two top level locations has to be picked
   * @param group the studio operations form
   * @returns a locationRequired error, or null once something is chosen
   */
  locationChoiceValidator = (group: FormGroup): ValidationErrors | null => {
    const chosen = group.get('soundStages')?.value || group.get('exteriorSets')?.value;
    return chosen ? null : { locationRequired: true };
  }

  /**
   * onNext() - Emits the studio operations selections and closes the modal
   */
  onNext(): void {
    const studioOperations = { ...this.operationsForm.value };
    this.studioOperationsSubmitted.emit(studioOperations);
    this.activeModal.close(studioOperations);
  }

  /**
   * onBack() - Returns to the production company step
   */
  onBack(): void {
    this.activeModal.dismiss('back');
  }

  /**
   * closeModal() - Dismisses the inquiry
   */
  closeModal(): void {
    this.activeModal.dismiss();
  }
}
